<template>
  <draggable
    v-if="pages"
    class="list-group"
    tag="div"
    :list="pages"
    group="shared"
    ghost-class="ghost"
    @sort="$emit('sort')"
    :move="checkMove"
  >
    <div v-for="el in pages" :key="el.name" class="list-group-item">
      <div>{{ el.name }}</div>
      <nested-draggable :pages="el.pages" />
    </div>
  </draggable>
</template>

<style>
  .pages>.list-group>.list-group-item:not(.ghost)>.list-group:empty {
    padding-bottom: 2em;
  }
</style>

<script>
  import draggable from "vuedraggable"
  export default {
    props: {
      pages: Array,
    },
    components: {
      draggable
    },
    name: "nested-draggable",
    methods: {
      checkMove(e) {
        let dropInFirstLevel = e.to.parentNode.className.indexOf('pages') >= 0
        let listGroup = e.dragged.querySelector('.list-group')
        if (listGroup &&
          listGroup.childElementCount > 0 &&
          !dropInFirstLevel)
          return false
        return true
      },
    },
  }
</script>